<template>
  <v-container id="cmu-historico" tag="section" fluid>
    <v-row align="center">
      <v-col cols="12">
        <cmu-data-table :items="items" :loadingItems="loadingItems" @rechargeTable="getAllValoresUnitarios()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CmuService from '@/services/parametrosComCa/CmuService';
  import dayjs from 'dayjs';

  export default {
    name: 'IndexCmu',

    components: {
      CmuDataTable: () => import('@/components/parametrosComCa/cmu/CmuDataTable.vue')
    },

    data() {
      return {
        items: [],
        loadingItems: false
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.getAllValoresUnitarios();
    },

    methods: {
      getAllValoresUnitarios() {
        this.loadingItems = true;

        CmuService.getAllValoresUnitarios()
          .then((response) => {
            this.items = [];
            response.data.valores.forEach((element) => {
              this.items.push({
                id: element.id,
                nome: element.nome,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created ? dayjs(element.created).format('DD/MM/YYYY HH:mm') : '-',
                modified: element.modified ? dayjs(element.modified).format('DD/MM/YYYY HH:mm') : '-'
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar dados dos CMU.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.loadingItems = false));
      }
    }
  };
</script>


<style>
  
</style>